import { START_FETCH_COUNTRIES, FETCH_COUNTRIES_SUCCESS, FETCH_COUNTRIES_FAILED} from '../actions/types';

const DEFAULT_STATE={
    countries:[]
}
export default(state=DEFAULT_STATE, action)=>{
    switch(action.type){
        case START_FETCH_COUNTRIES:
        return{
            ...state,
            countries:[]
        }
        case FETCH_COUNTRIES_SUCCESS:
            return{
                ...state,
                countries: action.payload
            }
        case FETCH_COUNTRIES_FAILED:
            return{
                ...state,
                countries:[]
            }
        default:
            return state
    }
}

